
import { Card } from "@/components/ui/card";
import { TransactionTypePieChart } from "./charts/TransactionTypePieChart";
import { TransactionAmountLineChart } from "./charts/TransactionAmountLineChart";
import { TransactionCountBarChart } from "./charts/TransactionCountBarChart";

interface TransactionChartsProps {
  transactions: any[];
}

export const TransactionCharts = ({ transactions }: TransactionChartsProps) => {
  if (!transactions || transactions.length === 0) {
    return (
      <div className="text-center p-8 text-gray-500">
        Aucune donnée disponible pour les graphiques
      </div>
    );
  }

  // Filtrer pour inclure tous les types de transactions
  const allTransactions = transactions.map(transaction => ({
    ...transaction,
    transaction_type: transaction.is_fully_paid === false ? "credit_sale" : transaction.transaction_type
  }));

  return (
    <div className="space-y-6">
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Vue d'ensemble des mouvements</h3>
          <div className="h-[300px]">
            <TransactionTypePieChart transactions={allTransactions} />
          </div>
        </Card>
        
        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Évolution des montants</h3>
          <div className="h-[300px]">
            <TransactionAmountLineChart transactions={allTransactions} />
          </div>
        </Card>
        
        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Fréquence des transactions</h3>
          <div className="h-[300px]">
            <TransactionCountBarChart transactions={allTransactions} />
          </div>
        </Card>
      </div>
    </div>
  );
};
